import { NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AddressHelper } from '../../../helpers/address.helper';
import { I18N_COUNTRY, I18N_NAMESPACE } from '../../../internal/constants';
import type { OnyxAddress } from '../../address-input/interfaces';
import { OnyxFlagComponent } from '../../flags/onyx-flag/onyx-flag.component';
import type { OnyxAddressFormat } from '../interfaces';

@Component({
  selector: 'onyx-address',
  imports: [UpperCasePipe, OnyxFlagComponent, TranslatePipe, NgTemplateOutlet],
  templateUrl: './onyx-address.component.html',
  styleUrl: './onyx-address.component.scss',
  host: { '[class.wrap]': 'wrap()' },
})
export class OnyxAddressComponent {
  public readonly address = input.required<OnyxAddress | null>();
  public readonly endAddress = input<OnyxAddress | null>(null);
  public readonly format = input.required<OnyxAddressFormat>();
  public readonly showFlag = input(true);
  public readonly wrap = input(false);

  protected readonly I18N = `${I18N_NAMESPACE}.address`;
  protected readonly I18N_COUNTRY = I18N_COUNTRY;

  protected coordinatesLabel = computed(() => {
    const address = this.address();
    return address ? AddressHelper.composeCoordinatesLabel(address) : null;
  });
}
